export default {
  props: {
    value: [String, Number, Array, Boolean, Object]
  }
};
